<template>
<div>
<div class="UserTop">
<span class="layui-icon aback"><router-link to="UserInfo" tag="a">&#xe603;</router-link></span>
<b>{{this.userPhoneName}}</b>
<div class="">
<div @click="myClick" :class="{active:isOn}" class="UserMy">我的</div>
<ul v-show="myOn" class="myInfo">
<!-- <li><router-link to="UserInfo" tag="a">个人中心</router-link></li> -->
<li><router-link to="ChangePassWord" tag="a">修改密码</router-link></li>
<!-- <li><router-link to="ChangeTel" tag="a">修改手机</router-link></li> -->
<!-- <li><router-link to="MyInfo" tag="a">查看个人资料</router-link></li> -->
<li><router-link to="SaveApply" tag="a">职位申请</router-link></li>
<li><router-link to="MyApply" tag="a">我的申请</router-link></li>
<li @click="quitEnter">退出登录</li>
</ul>
</div>
</div>
<div id="markbg" v-show="markbg" @click="markClick"></div>
</div>
</template>
<script>
export default {
    name: 'UserTop',
    data () {
        return {
            myOn:false,
            markbg:false,
            isOn:false,
            userPhoneName:"",
        }
    },
    mounted () {
       this.loadComments(); 
    },
    methods: {
        myClick(){
            this.myOn = !this.myOn;
            this.markbg = !this.markbg;
            if(this.isOn == false){
                this.isOn = true
            }else{
                this.isOn = false
            }
        },
        markClick(){
            this.myOn = false;
            this.markbg= false;
        },
        loadComments() {
            this.userPhoneName = localStorage.getItem("userPhoneName");
            //this.userPhoneName = UsPN;
            //console.log(this.user_id);
        },
        quitEnter () {
            this.$router.push('/');
            localStorage.clear();
        }
    }
}
</script>
<style scoped>
.UserTop{background:#333;color:#fff;display:flex;font-size:1.5rem;line-height:5rem;padding:0 1rem;position:relative;z-index:19;text-align:center;}
.UserTop b{flex:1;font-weight:normal;}
.aback{color:#fff;font-size:2.6rem;}
.aback a{color:#fff;}
.myInfo{position:absolute;right:0;top:4rem;background:#333;padding:1rem;white-space:nowrap;text-align:center;z-index:999;}
.myInfo a{color:#fff;}
.UserMy{position:relative;padding-right:2rem;}
.UserMy:after,.active::after{content:"";display:block;border-width:.6rem;border-style:solid;border-color:#0099CC transparent transparent transparent;position:absolute;right:0;top:43%;}
.active::after{border-color:transparent transparent #0099CC transparent;top:30%;}
#markbg{width:100%;height:100%;position:fixed;left:0;top:0;background:rgba(0,0,0,.6);z-index:9;}
</style>